import React from 'react'

function CancelSubscription() {
    return (
        <div>CancelSubscription</div>
    )
}

export default CancelSubscription